const protocol = window.location.protocol;
export const DOMAIN = protocol + '//wenjuan.58.com';

export const __SURVEY__ = {
    getSurvey: DOMAIN+'/survey/get'
}



// WEBPACK FOOTER //
// ./src/utils/api.js